import { createBrowserRouter } from 'react-router-dom';

import { LayoutPublic } from 'app/layouts';
import { NotFound } from 'pages/NotFound';
import { Offer } from 'pages/public';
import { EMainRoutes } from 'shared/typings';

export const routerPublic = [
	{
		path: `/${EMainRoutes.PUBLIC}`,
		element: <LayoutPublic />,
		errorElement: <LayoutPublic outlet={<NotFound />} />,
		children: [
			{
				path: '',
				element: <NotFound />,
			},
			{
				path: `${EMainRoutes.OFFER}/:slug`,
				element: <Offer />,
			},
			{
				path: '*',
				element: <NotFound />,
			},
		],
	},
];

export const routerPublicApp = createBrowserRouter(routerPublic);
